export const AIROPS_WIDGET_URL = 'https://assets.airops.com/widget/index.js';
export const AIROPS_WIDGET_ID = '36faca9b-4fa4-4c98-877f-225e9488abea';